/**
 * 套件
 * @type {string}
 */
const autoSuiteSet = [
    'AutomaticSuite',
    'AutomaticOrderSuite',
    'AutomaticPurchaseQuotedPriceSuite',
    'AutomaticIotApplicationFeedingSuite',
    'AutomaticInventoryCheckSuite'
];

const editSuiteSet = [
    'AutomaticSuite',
    'AutomaticPurchaseQuotedPriceSuite'
];

const Mixins = {
    methods: {
        isSuiteCompnent(compnentName) {
            return autoSuiteSet.indexOf(compnentName) >= 0;
        },

        isEditSuiteCompnent(compnentName) {
            return editSuiteSet.indexOf(compnentName) >= 0;
        }
    }
}

export default Mixins;
